/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/KeyboardNavigator',[],function () {
    /*
    public interface IKeyboardNavigatable
    {
        KeyboardNavigator Keyboard { get; }
        SupplyView SupplyView { get; }
        bool OnGetKeyboardFocus();
        void OnLoseKeyboardFocus();
        bool TryHandleKeypress(KeyboardNavigator.KeyPress key);

        // this will be called when the item is ready to unregister its events
        void UnregisterEvents();
    }
    */

   var KeyboardNavigator = function (host) {
       this.initKeyboardNavigator(host);
   };

    KeyboardNavigator.prototype.initKeyboardNavigator = function (host) {
        this.Host = host;
        this.KeypressActions = [];
        this.HasKeyboardFocus = false;
    };


    /// <summary>
    /// Action to call when a pile keypress is detected. Returns true if it handled the keypress.
    /// </summary>
    /// <param name="pileview"></param>
    /// <param name="keyDirection"></param>
    /// <returns></returns>
    // public delegate bool KeypressAction(IKeyboardNavigatable pileview, KeyPress keyDirection);

    /// <summary>
    /// An action to take on keypress. If PileToFocus is not null, attempt to focus that PileView.
    /// If DelegateToInvoke is not null, call it and assume it will change focus or return false.
    /// If both conditions are met, the result is undefined, so only set one or the other!
    /// </summary>
    KeyboardNavigator.KeyAction = function (pileOrDelegate) {
        this.initKeyAction(pileOrDelegate);
    };

    KeyboardNavigator.KeyAction.prototype.initKeyAction = function (pileOrDelegate) {
        this.DelegateToInvoke = null;
        this.PileToFocus = null;

        if (typeof pileOrDelegate.Pile !== 'undefined') {
            this.PileToFocus = pileOrDelegate;
        } else {
            this.DelegateToInvoke = pileOrDelegate;
        }
    };


    KeyboardNavigator.KeyPress = {INVALID: 0, Activate: 1, Up: 2, Down: 3, Left: 4, Right: 5, Tab: 6, ShiftTab: 7};

    KeyboardNavigator.KeyPressCharMap = {
        '38':'Up',
        '40':'Down',
        '37':'Left',
        '39':'Right',
        '9':'Tab',
        '32':'Activate', // spacebar
        '13':'Activate', // enter
        '13':'Activate',
        '18':'Alt',
        '91': 'Ctrl',
        '93': 'Ctrl',
        '224': 'Ctrl',
        '17': 'Ctrl',
        '90': 'Z',
        '72': 'hintAction',
        '112': 'openHowToPlay',
        '113': 'NewGame',
        '115': 'Statistics',
        //'116': 'Options', // f5
        '68': 'Draw',
        '27': 'Menu', // esc key
        '8': 'Back' // backspace
    };

    KeyboardNavigator.prototype.RegisterKeypressHandler = function (key, pileToFocus)
    {
        if (pileToFocus == null)
            return;

        if (!this.KeypressActions[key])
        {
            this.KeypressActions[key] = [];
        }
        this.KeypressActions[key].push(new KeyboardNavigator.KeyAction(pileToFocus));
    };

    KeyboardNavigator.prototype.ResetKeypressHandlers = function ()
    {
        this.KeypressActions = [];
    };


    /// <summary>
    /// Attempts to get keyboard focus. If the PileView doesn't want it, it will return false.
    /// </summary>
    /// <returns></returns>
    KeyboardNavigator.prototype.ProcessKeyActions = function (key)
    {
        var success = false;
        if (this.KeypressActions[key])
        {
            var actions = this.KeypressActions[key];
            for  (var i = 0; i < actions.length; i ++)
            {
                var action = actions[i];
                if (action.PileToFocus != null)
                {
                    if (action.PileToFocus.Keyboard.GetKeyboardFocus())
                    {
                        // we gave up focus successfully!
                        this.LoseKeyboardFocus();
                        success = true;
                        break;
                    }
                }
                else if (action.DelegateToInvoke != null)
                {
                    if (action.DelegateToInvoke(this.Host, key))
                    {
                        // delegate successfully took focus, so give up ours.
                        this.LoseKeyboardFocus();
                        success = true;
                        break;
                    }
                }
            }
            // Had no successful actions, oh well! Guess we're keeping focus.
        }
        return success;
    };

    KeyboardNavigator.prototype.GetKeyboardFocus = function ()
    {
        if (this.Host.OnGetKeyboardFocus())
        {
            this.Host.SupplyView.KeyboardFocus = this.Host;
            this.HasKeyboardFocus = true;
            return true;
        }
        return false;
    };

    KeyboardNavigator.prototype.LoseKeyboardFocus = function ()
    {
        this.Host.OnLoseKeyboardFocus();
        this.HasKeyboardFocus = false;
    };

    KeyboardNavigator.prototype.HandleKeypress = function (key)
    {
        if (!this.Host.SupplyView.KeyboardEnabled)
            return;

        // let the host handle it first, otherwise we do
        if (!this.Host.TryHandleKeypress(key))
            this.ProcessKeyActions(key);
    };



    return KeyboardNavigator;
});
